import { render, staticRenderFns } from "./BusquedaAntecedentesView.vue?vue&type=template&id=7206c4c1&scoped=true&"
import script from "./BusquedaAntecedentesView.vue?vue&type=script&lang=js&"
export * from "./BusquedaAntecedentesView.vue?vue&type=script&lang=js&"
import style0 from "./BusquedaAntecedentesView.vue?vue&type=style&index=0&id=7206c4c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7206c4c1",
  null
  
)

export default component.exports